import { render, staticRenderFns } from "./CallNumPanel.vue?vue&type=template&id=2575a465&scoped=true"
import script from "./CallNumPanel.vue?vue&type=script&lang=js"
export * from "./CallNumPanel.vue?vue&type=script&lang=js"
import style0 from "./CallNumPanel.vue?vue&type=style&index=0&id=2575a465&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2575a465",
  null
  
)

export default component.exports